import { render } from "./LongtermTable.vue?vue&type=template&id=4533f4a0"
import script from "./LongtermTable.vue?vue&type=script&lang=js"
export * from "./LongtermTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__